import React from 'react'
import { useNavigate } from 'react-router-dom'
import { FiUsers, FiBell, FiSettings, FiTool } from 'react-icons/fi'

const MODULES = [
  { path: '/users', label: 'Utenti', desc: 'Gestisci utenti, soci e permessi', icon: FiUsers },
  { path: '/notifications', label: 'Notifiche', desc: 'Invia notifiche push ai soci', icon: FiBell },
  { path: '/automations', label: 'Automazioni', desc: 'Soglie calibrature e alert automatici', icon: FiSettings },
  { path: '/maintenance', label: 'Manutenzioni', desc: 'Pratiche, macchine e storico interventi', icon: FiTool }
]

export default function Dashboard () {
  const navigate = useNavigate()

  return (
    <div>
      <div className='ui-page-header'>
        <h3>Dashboard</h3>
      </div>
      <div className='ui-stats-grid'>
        {MODULES.map(mod => (
          <div
            key={mod.path}
            className='ui-stat-card clickable'
            onClick={() => navigate(mod.path)}
            style={{ cursor: 'pointer' }}
          >
            <mod.icon style={{ fontSize: '1.6rem', color: 'var(--sf-green-600)', marginBottom: 8 }} />
            <strong style={{ fontSize: '1.1rem' }}>{mod.label}</strong>
            <span style={{ textTransform: 'none', letterSpacing: 0 }}>{mod.desc}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
